import cx from 'classnames';
import styles from './UserInfo.module.scss';

import { FC, useContext } from 'react';

import { NavLink, useLocation, useNavigate } from 'react-router-dom';

import { ExitIcon } from '@assets/icons';
import { useLogout } from '@utils/hooks';
import { Typography } from '@shared/Typography';
import { Avatar } from '@shared/Avatar';
import { AppContext } from '@app/providers';
import { useAppSelector } from '@app/store';
import { PATH } from '@app/index';
import { RawButton } from '@shared/RawButton';

interface UserInfoProps {
  avatar?: string;
  username: string;
  displayNumber?: number;
  avatarIsLoading?: boolean;
  userAccountLink?: string;
}

export const UserInfo: FC<UserInfoProps> = ({
  avatar,
  username,
  displayNumber,
  avatarIsLoading = false,
  userAccountLink,
}) => {
  const nav = useNavigate();
  const { logout } = useLogout();
  const { pathname } = useLocation();
  const { isTelegramBot } = useContext(AppContext);
  const { initData } = useAppSelector((s) => s.user.tgUserData);

  const isProfilePage = pathname === PATH.ACCOUNT;

  return (
    <div
      className={styles.uiContainer}
      onDoubleClick={() => navigator.clipboard.writeText(initData)}
    >
      <NavLink
        to={userAccountLink ?? '#'}
        className={cx(styles.uiUser, {
          [styles.uiUserClickable]: userAccountLink,
          [styles.uiAccount]: isProfilePage,
        })}
      >
        <div className={styles.uiAvatarWrapper}>
          <Avatar
            className={cx(styles.uiAvatar, { [styles.uiAvatarAccount]: isProfilePage })}
            src={!avatarIsLoading && avatar ? avatar : ''}
          />
        </div>

        <div className={styles.uiInfo}>
          <Typography
            component="h2"
            className={cx(styles.uiUsername, {
              [styles.uiUsernameAccount]: isProfilePage,
            })}
          >
            {username}
          </Typography>

          {isProfilePage && displayNumber && (
            <Typography component="h2" variant="secondary" className={styles.uiUserId}>
              {`#${displayNumber}`}
            </Typography>
          )}
        </div>
      </NavLink>
      {!isTelegramBot && (
        <RawButton
          className={styles.exitIcon}
          onClick={() => {
            logout();
            if (pathname !== PATH.LANDING && pathname !== PATH.FAQ) nav(PATH.LANDING);
          }}
        >
          <ExitIcon />
        </RawButton>
      )}
    </div>
  );
};
